import {
  type SelectModelPortfolioEditTypeOptions,
  SelectModelPortfolioEditTypeVisual,
} from './selectModelPortfolioEditType.visual';

/**
 * Routes the household model portfolio edit workflow down one of four branches.
 *
 * Nothing is persisted here: the chosen branch key is handed straight to
 * nextSubStep, which matches it against the branch an admin drew from the
 * matching handle in the workflow editor.
 */
export const SelectModelPortfolioEditType = ({
  options,
  onNext,
  stepLoading,
}: {
  options: SelectModelPortfolioEditTypeOptions;
  onNext: (branchKey?: string) => void | Promise<void>;
  stepLoading?: boolean;
}) => (
  <SelectModelPortfolioEditTypeVisual
    options={options}
    loading={stepLoading}
    onNext={onNext}
  />
);

export default SelectModelPortfolioEditType;
